import { render, staticRenderFns } from "./GroupsDesserts.vue?vue&type=template&id=7275390e&"
import script from "./GroupsDesserts.vue?vue&type=script&lang=js&"
export * from "./GroupsDesserts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports